// extracted by mini-css-extract-plugin
export default {"ellipsis":"EllipsisText_ellipsis__dq6XW"};